<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="width"
    :height="height"
    viewBox="0 0 82 100"
  >
    <defs>
      <path
        id="prefix__a"
        d="M16.07 0C10.166 0 5.361 4.779 5.361 10.643V50H4.315C1.932 50 0 51.919 0 54.288v26.011c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77c0 5.871 4.805 10.642 10.707 10.643h55.141c5.899-.001 10.705-4.774 10.705-10.643V25.189L56.48 0M11.922 10.643c0-2.269 1.862-4.119 4.148-4.119l37.957-.039v13.946c0 4.072 3.325 7.38 7.426 7.38l13.742-.04.157 61.586c0 2.274-1.858 4.124-4.145 4.124H16.07c-2.286 0-4.148-1.85-4.148-4.124v-4.77h51.4c2.384 0 4.317-1.918 4.317-4.288v-26.01c0-2.37-1.933-4.289-4.317-4.289h-51.4"
      />
      <path
        id="prefix__c"
        d="M16.07 0C10.166 0 5.361 4.779 5.361 10.643V50H4.315C1.932 50 0 51.919 0 54.288v26.011c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77c0 5.871 4.805 10.642 10.707 10.643h55.141c5.899-.001 10.705-4.774 10.705-10.643V25.189L56.48 0M11.922 10.643c0-2.269 1.862-4.119 4.148-4.119l37.957-.039v13.946c0 4.072 3.325 7.38 7.426 7.38l13.742-.04.157 61.586c0 2.274-1.858 4.124-4.145 4.124H16.07c-2.286 0-4.148-1.85-4.148-4.124v-4.77h51.4c2.384 0 4.317-1.918 4.317-4.288v-26.01c0-2.37-1.933-4.289-4.317-4.289h-51.4"
      />
      <path
        id="prefix__e"
        d="M16.07 0C10.166 0 5.361 4.779 5.361 10.643V50H4.315C1.932 50 0 51.919 0 54.288v26.011c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77c0 5.871 4.805 10.642 10.707 10.643h55.141c5.899-.001 10.705-4.774 10.705-10.643V25.189L56.48 0M11.922 10.643c0-2.269 1.862-4.119 4.148-4.119l37.957-.039v13.946c0 4.072 3.325 7.38 7.426 7.38l13.742-.04.157 61.586c0 2.274-1.858 4.124-4.145 4.124H16.07c-2.286 0-4.148-1.85-4.148-4.124v-4.77h51.4c2.384 0 4.317-1.918 4.317-4.288v-26.01c0-2.37-1.933-4.289-4.317-4.289h-51.4"
      />
      <path
        id="prefix__g"
        d="M16.07 0C10.166 0 5.361 4.779 5.361 10.643V50H4.315C1.932 50 0 51.919 0 54.288v26.011c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77c0 5.871 4.805 10.642 10.707 10.643h55.141c5.899-.001 10.705-4.774 10.705-10.643V25.189L56.48 0H16.07zm-4.148 10.643c0-2.269 1.862-4.119 4.148-4.119l37.957-.039v13.946c0 4.072 3.325 7.38 7.426 7.38l13.742-.04.157 61.586c0 2.274-1.858 4.124-4.145 4.124H16.07c-2.286 0-4.148-1.85-4.148-4.124v-4.77h51.4c2.384 0 4.317-1.918 4.317-4.288v-26.01c0-2.37-1.933-4.289-4.317-4.289h-51.4V10.643z"
      />
      <path
        id="prefix__i"
        d="M0 12c0 6.607 5.394 11.999 12 11.999 6.577 0 12-5.372 12-11.999 0-3.193-1.284-6.189-3.549-8.452C18.187 1.284 15.192 0 12 0 5.407 0 0 5.396 0 12zm6.614-7.383A9.043 9.043 0 0112 2.859 9.128 9.128 0 0121.141 12c0 1.969-.62 3.839-1.772 5.385L6.614 4.617zM2.859 12c0-1.969.619-3.839 1.758-5.386l12.769 12.755A8.955 8.955 0 0112 21.14 9.129 9.129 0 012.859 12z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <mask id="prefix__b" fill="#fff">
        <use xlink:href="#prefix__a" />
      </mask>
      <path
        fill="#B8E3ED"
        d="M9.518 63.746H8.387v6.526h.912c2.047 0 3.07-1.1 3.07-3.297 0-2.153-.95-3.23-2.851-3.23"
        mask="url(#prefix__b)"
      />
      <mask id="prefix__d" fill="#fff">
        <use xlink:href="#prefix__c" />
      </mask>
      <path
        fill="#B8E3ED"
        d="M60.071 64.048c-.327-.201-.833-.302-1.519-.302h-.644v2.708h.685c.672 0 1.168-.112 1.488-.336.32-.223.48-.576.48-1.055 0-.476-.163-.814-.49-1.015"
        mask="url(#prefix__d)"
      />
      <g>
        <mask id="prefix__f" fill="#fff">
          <use xlink:href="#prefix__e" />
        </mask>
        <path
          fill="#B8E3ED"
          d="M20.24 63.52c-.152.585-.584 2.031-1.297 4.34h2.612a685.181 685.181 0 01-1.134-3.669 10.42 10.42 0 01-.182-.67"
          mask="url(#prefix__f)"
        />
      </g>
      <g>
        <mask id="prefix__h" fill="#fff">
          <use xlink:href="#prefix__g" />
        </mask>
        <path
          :fill="iconColor"
          d="M61.432 72.027l-2.393-3.846h-1.13v3.846h-2.126V62.005h2.92c1.362 0 2.37.248 3.023.744.654.496.981 1.25.981 2.258 0 .59-.162 1.115-.487 1.574-.324.46-.784.82-1.378 1.08a391.624 391.624 0 002.948 4.366h-2.358zm-7.74-8.28h-3.647v2.2h3.394v1.741h-3.394v2.584h3.647v1.755H47.92V62.005h5.772v1.741zm-8.157 7.848c-.645.21-1.25.358-1.82.443-.57.084-1.15.126-1.745.126-1.513 0-2.668-.445-3.465-1.333-.798-.889-1.197-2.165-1.197-3.828 0-1.619.463-2.88 1.39-3.785.924-.905 2.207-1.357 3.848-1.357 1.028 0 2.02.205 2.975.617l-.706 1.7a5.051 5.051 0 00-2.283-.548c-.919 0-1.655.308-2.207.924-.554.618-.83 1.448-.83 2.49 0 1.087.223 1.918.668 2.491.446.574 1.094.86 1.944.86.443 0 .893-.045 1.35-.137v-2.09h-1.899V66.4h3.977v5.196zm-10.304.432h-2.7l-4.36-7.582h-.062c.087 1.34.13 2.294.13 2.865v4.717H26.34V62.005h2.681l4.353 7.506h.048c-.069-1.302-.103-2.223-.103-2.762v-4.744h1.912v10.022zm-12.442 0l-.727-2.386H18.41l-.727 2.386h-2.29l3.538-10.063h2.598l3.551 10.063h-2.29zm-9.62-1.316c-.94.878-2.297 1.316-4.07 1.316H6.261V62.005h3.147c1.636 0 2.906.431 3.811 1.295.905.864 1.358 2.071 1.358 3.62 0 1.65-.47 2.914-1.409 3.791zM-5 105.001h91.914V-5H-5v110z"
          mask="url(#prefix__h)"
        />
      </g>
      <g transform="translate(21 15)">
        <mask id="prefix__j" fill="#fff">
          <use xlink:href="#prefix__i" />
        </mask>
        <path fill="#B8E3ED" d="M-5 29L29 29 29 -5 -5 -5z" mask="url(#prefix__j)" />
      </g>
      <path
        :stroke="stroke"
        stroke-width="3"
        d="M33 15c-6.593 0-12 5.396-12 12 0 6.607 5.394 12 12 12 6.577 0 12-5.372 12-12 0-3.192-1.284-6.188-3.549-8.452C39.187 16.284 36.192 15 33 15zm0 21.14A9.13 9.13 0 0123.859 27c0-1.97.619-3.84 1.758-5.386l12.769 12.755A8.963 8.963 0 0133 36.14zm7.369-3.754l-12.755-12.77A9.043 9.043 0 0133 17.86a9.129 9.129 0 019.141 9.14 8.97 8.97 0 01-1.772 5.387z"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-danger',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      },
      stroke: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>

<style scoped></style>
